import { Flex, Group, Table, UnstyledButton } from "@mantine/core";

import { Icon as TablerIcon } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

interface EmptyRowProps {
  text: string;
  Icon?: TablerIcon;
  addButtonLabel?: string;
  onAdd?: () => void;
  addButtonColor?: string;
}

export default function EmptyRow({
  Icon,
  text,
  addButtonLabel = "Add new",
  onAdd,
  addButtonColor = "gray.7",
}: EmptyRowProps) {
  return (
    <Table.Tr>
      <Table.Td colSpan={12}>
        <Flex py="lg" mx={-8} gap="xs" bg="gray.0" align="center" justify="center">
          {Icon && <Icon style={{ color: "var(--mantine-color-gray-6)" }} />}
          <Group gap={4}>
            <TextWrapper c="gray.7">{text}</TextWrapper>
            {onAdd && (
              <UnstyledButton onClick={onAdd}>
                <TextWrapper variant="bold" td="underline" c={addButtonColor}>
                  {addButtonLabel}
                </TextWrapper>
              </UnstyledButton>
            )}
          </Group>
        </Flex>
      </Table.Td>
    </Table.Tr>
  );
}
